module.exports = __webpack_public_path__ + "img/pin-triplo-diamante.40d1191e.png";